import { AssetEntry } from '../AssetEntry';
import { Page } from '../Page';
import { ShortBlogData } from '../ShortBlogData';
import { TopicCluster } from '../TopicCluster';

export enum PillarType {
  ADVERTISER = 'advertiser',
  TENANT = 'tenant',
}

export interface PillarContentData {
  title: string;
  text: string;
  relatedArticles: ShortBlogData[];
  ctaTitle?: string;
  ctaText?: string;
  ctaUrlTutle?: string;
  ctaUrl?: string;
}

export interface PillarRequiredData {
  pillarType: PillarType;
  metaTitle: string;
  metaDescription: string;
  title: string;
  authorName: string;
  authorAvatarAsset?: AssetEntry;
  authorAvatar: string;
  introduction: string;
  contentBlocks: PillarContentData[];
  conclusionTitle: string;
  conclusionText: string;
  updatedAt: string;
  createdAt: string;
  headerImageAsset?: AssetEntry;
  headerImage: string;
  parentUrl: string;
  parentTitle: string;
}

export interface PillarPageData extends PillarRequiredData {
  formTitle: string | undefined | null;
  formText: string | undefined | null;
  hideReadingTime: boolean;
  topicCluster?: TopicCluster;
}

export type PillarPage = Page<'Pillar', PillarPageData>;
